import { render, staticRenderFns } from "./addEditModal.vue?vue&type=template&id=34476d08&scoped=true&"
import script from "./addEditModal.vue?vue&type=script&lang=tsx&"
export * from "./addEditModal.vue?vue&type=script&lang=tsx&"
import style0 from "./addEditModal.vue?vue&type=style&index=0&id=34476d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34476d08",
  null
  
)

export default component.exports